import ENV from "config/Env";
import { backendQueryKey, permanentBackendQueryKey } from "hooks/useTypedQuery";

import type { Checklist, ChecklistID, ChecklistTemplateShort, DealerID, DealerLocationID, Question, Tag } from "models";

const component = "ChecklistsDashboard";

export const ChecklistsDashboardQueryKeys = {
  locationChecklists: (id?: DealerLocationID) =>
    backendQueryKey<Checklist[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/locations/details", params: { id, embed: "checklist" } }),
  dealerChecklists: (id?: DealerID) =>
    backendQueryKey<Checklist[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/dealers/details", params: { id, embed: "checklist" } }),
  defaultChecklists: backendQueryKey<Checklist[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/checklists/mylist" }),
  checklistDetails: (id?: ChecklistID) =>
    backendQueryKey<Checklist>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/checklists/view", params: { id, embed: "attached_to,question_group" } }),
  checklistTemplates: backendQueryKey<ChecklistTemplateShort[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/checklists/template/list_short" }),
  tags: permanentBackendQueryKey<Tag[]>({ component, baseUrl: ENV.systemBaseURL, endpoint: "/tags/list" }),
  dealerQuestions: (id?: DealerID) => backendQueryKey<Question[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/questions/search", params: { id } }),
  defaultQuestions: backendQueryKey<Question[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/questions/default" })
};
